import React, { useState, FC, useEffect } from "react";
import Container from "../../components/layout/Container/Container"; // Corrected typo "Contaier" to "Container"
import Banner from "../../components/layout/Sections/Banner";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { SampleData } from "../../typings/models/SampleData";
import { notify } from "../../utils";
import { NotifyType } from "../../utils/app-config";
import { IProjectDetails } from "../../typings/models/ProjectDetails";
const { message } = notify();

interface PersonalInfo {
  customerName: string;
  mobileNumber: string;
  email: string;
  address: string;
  nric: string;
  homeNumber: string;
  paymentMethod: string;
}

const initialPersonalInfo: PersonalInfo = {
  customerName: "Ramesh",
  mobileNumber: "+65 98765678",
  email: "jeremy.ten@gmail.com",
  address: "30 Sembawang Drive Sun Plaza Singapore 757713",
  nric: "5671",
  homeNumber: "+65 98765678",
  paymentMethod: "Giro",
};

const isValidEmail = (email: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const ProjectDetails = () => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [typeOfServices, setTypeOfServices] = useState<string>("");
  const [typeOfApplication, setTypeOfApplication] = useState<string>("");
  const [projectName, setProjectName] = useState<string>("");
  const [supportDocuments, setSupportDocuments] = useState<File | null>(null);
  const [specialInstructions, setSpecialInstructions] = useState<string>("");
  const [otherRemarks, setOtherRemarks] = useState<string>("");
  const [projectDetails, setProjectDetails] = useState<IProjectDetails>();
  const [emailError, setEmailError] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const {
    personalInfo: passedPersonalInfo,
    samples: passedSamples,
    testsToDisplay: passedTestsToDisplay,
  } = location.state || {
    personalInfo: initialPersonalInfo,
    testsToDisplay: [],
  };
  const [samples, setSamples] = useState(passedSamples);
  const [personalInfo, setPersonalInfo] =
    useState<PersonalInfo>(passedPersonalInfo);
  const [testsToDisplay, setTestsToDisplay] = useState(passedTestsToDisplay);

  useEffect(() => {
    const passedState = location.state as {
      personalInfo: PersonalInfo;
      samples: SampleData[];
      typeOfServices: string;
      typeOfApplication: string;
    };

    if (passedState) {
      setPersonalInfo(passedState.personalInfo || initialPersonalInfo);
      setSamples(passedState.samples);
      setTypeOfServices(passedState.typeOfServices);
      setTypeOfApplication(passedState.typeOfApplication);
    }
  }, [location]);

  useEffect(() => {
    const sampleLocalStorageStr: string =
      localStorage.getItem("lab-project-details") || "";
    if (sampleLocalStorageStr?.length) {
      let locallayStored: IProjectDetails = JSON.parse(sampleLocalStorageStr);
      setSpecialInstructions(locallayStored.specialInstruction);
      setProjectName(locallayStored.projectName);
      setOtherRemarks(locallayStored.otherRemarks);
    }
  }, []);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setSupportDocuments(event.target.files[0]);
    }
  };

  const handlePersonalInfoChange = (key: keyof PersonalInfo, value: string) => {
    setPersonalInfo({ ...personalInfo, [key]: value });
    if (key === "email") {
      setEmailError(
        value && !isValidEmail(value) ? "Please enter a valid email address." : ""
      );
    }
  };

  const handlePersonalInfoUpdate = () => {
    if (personalInfo.email && !isValidEmail(personalInfo.email)) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    handleCloseModal();
  };
  // const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //     setSelectedType(event.target.value);
  // };

  const handleNextClick = () => {
    let borderDanger = document.getElementsByClassName("border-danger");
    if (borderDanger.length > 0) {
      message(NotifyType.Error, "Please fill the mandatory fields.");
      return;
    }

    storeProjectsInLocalStorage();
    navigate("/cost-and-confirm", {
      state: {
        personalInfo:
          personalInfo !== initialPersonalInfo ? personalInfo : undefined,
        typeOfServices: typeOfServices,
        typeOfApplication: typeOfApplication,
        samples: passedSamples,
        projectName: projectName,
        supportDocuments: supportDocuments,
        specialInstructions: specialInstructions,
        otherRemarks: otherRemarks,
        testsToDisplay: testsToDisplay,
      },
    });
  };

  const storeProjectsInLocalStorage = () => {
    // store on the local storage
    let proj: IProjectDetails = {
      projectName: projectName,
      specialInstruction: specialInstructions,
      otherRemarks: otherRemarks,
    };
    localStorage.setItem("lab-project-details", JSON.stringify(proj));
  };

  const handlePreviousClick = () => {
    // Navigate to the ChooseApplication route
    navigate("/samples-and-tests");
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab"> Application for Laboratory Testing </div>
        <div className="stepwizard">
          <div className="stepwizard-row setup-panel row">
            <div className="stepwizard-step offset-sm-2 col-2 current-active">
              <a
                data-id="#step-1"
                type="button"
                className="btn  btn-border btn-primary"
              >
                <span className="step-circle">
                  <p>1</p>
                </span>
              </a>
              <p>Choose Application</p>
            </div>
            <div className="stepwizard-step col-2">
              <a
                data-id="#step-2"
                type="button"
                className="btn btn-border disabled"
              >
                <span className="step-circle">
                  <p>2</p>
                </span>
              </a>
              <p>Samples & Tests</p>
            </div>
            <div className="stepwizard-step col-2 ">
              <a
                data-id="#step-3"
                type="button"
                className="btn btn-border disabled"
              >
                <span className="step-circle">
                  <p>3</p>
                </span>
              </a>
              <p>Project Details</p>
            </div>
            <div className="stepwizard-step col-2">
              <a
                data-id="#step-4"
                type="button"
                className="btn btn-border disabled"
              >
                <span className="step-circle">
                  <p>4</p>
                </span>
              </a>
              <p>Cost & Confirm</p>
            </div>
          </div>
        </div>
        <div className="row setup-content" id="step-3">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              <div className="personal-info">
                <div className="info-heading">
                  <a
                    href="#"
                    className="edit-icon float-end"
                    onClick={handleShowModal}
                  >
                    <i className="fa fa-pencil-square-o"></i> Edit
                  </a>

                  {/* <button className="edit-icon float-end" onClick={toggleEditMode}>
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </button> */}

                  <h2>Personal Information</h2>
                </div>

                <div className="info-content">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Customer Name</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="customerName"
                              value={personalInfo.customerName}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "customerName",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.customerName}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Mobile Number</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="mobileNumber"
                              value={personalInfo.mobileNumber}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "mobileNumber",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.mobileNumber}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Email</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="email"
                              value={personalInfo.email}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "email",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.email}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Address</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="address"
                              value={personalInfo.address}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "address",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.address}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Customer NRIC</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="nric"
                              value={personalInfo.nric}
                              onChange={(e) =>
                                handlePersonalInfoChange("nric", e.target.value)
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.nric}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Office/Home Number</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="homeNumber"
                              value={personalInfo.homeNumber}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "homeNumber",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.homeNumber}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <h6>Made of Payment</h6>
                        </div>
                        <div className="col-md-8">
                          {isEditMode ? (
                            <input
                              type="text"
                              id="paymentMethod"
                              value={personalInfo.paymentMethod}
                              onChange={(e) =>
                                handlePersonalInfoChange(
                                  "paymentMethod",
                                  e.target.value
                                )
                              }
                            />
                          ) : (
                            <p>
                              <small>:</small> {personalInfo.paymentMethod}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="personal-info">
                <div className="info-heading">
                  <h2>Project Details</h2>
                </div>
                <div className="info-content">
                  <form>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="mb-3 row">
                          <label
                            htmlFor="projectName"
                            className="col-sm-4 col-form-label"
                          >
                            Project Name/Location
                            <span className="star-red">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className={`form-control ${
                                !projectName ? "border-danger op05" : ""
                              }`}
                              placeholder=""
                              id="projectName"
                              value={projectName}
                              onChange={(e) => setProjectName(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3 row">
                          <label
                            htmlFor="inputGroupFile04"
                            className="col-sm-4 col-form-label"
                          >
                            Support Documents<span className="star-red">*</span>
                          </label>
                          <div className="col-sm-8">
                            <div className="input-group">
                              <input
                                type="file"
                                className="form-control"
                                id="inputGroupFile04"
                                onChange={handleFileChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3 row">
                          <label
                            htmlFor="specialInstructions"
                            className="col-sm-4 col-form-label"
                          >
                            Special Instructions/Additional Information
                          </label>
                          <div className="col-sm-8">
                            <textarea
                              className="form-control"
                              placeholder=""
                              id="specialInstructions"
                              value={specialInstructions}
                              onChange={(e) =>
                                setSpecialInstructions(e.target.value)
                              }
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="mb-3 row">
                          <label
                            htmlFor="otherRemarks"
                            className="col-sm-4 col-form-label"
                          >
                            Other Remarks
                          </label>
                          <div className="col-sm-8">
                            <textarea
                              className="form-control"
                              placeholder=""
                              id="otherRemarks"
                              value={otherRemarks}
                              onChange={(e) => setOtherRemarks(e.target.value)}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="text-end mt-3 mb-3">
                <button
                  className="btn btn-secondry  px-4"
                  onClick={storeProjectsInLocalStorage}
                >
                  Save Draft
                </button>
                <button
                  className="btn btn-secondary px-4"
                  onClick={handlePreviousClick}
                >
                  Previous
                </button>
                <button
                  className="btn btn-primary nextBtn"
                  type="button"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
      {/* Modal Component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Personal Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="customerName" className="form-label">
                      Customer Name
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="text"
                      id="customerName"
                      className="form-control"
                      value={personalInfo.customerName}
                      onChange={(e) =>
                        handlePersonalInfoChange("customerName", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="nric" className="form-label">
                      Customer NRIC
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="text"
                      id="nric"
                      className="form-control"
                      value={personalInfo.nric}
                      onChange={(e) =>
                        handlePersonalInfoChange("nric", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="mobileNumber" className="form-label">
                      Mobile Number
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="number"
                      id="mobileNumber"
                      className="form-control"
                      value={personalInfo.mobileNumber}
                      onChange={(e) =>
                        handlePersonalInfoChange("mobileNumber", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="homeNumber" className="form-label">
                      Office/Home Number
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="text"
                      id="homeNumber"
                      className="form-control"
                      value={personalInfo.homeNumber}
                      onChange={(e) =>
                        handlePersonalInfoChange("homeNumber", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="email"
                      id="email"
                      className={`form-control ${emailError ? "is-invalid" : ""}`}
                      value={personalInfo.email}
                      onChange={(e) =>
                        handlePersonalInfoChange("email", e.target.value)
                      }
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="paymentMethod" className="form-label">
                      Made of Payment
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <select
                      className="form-select"
                      id="paymentMethod"
                      value={personalInfo.paymentMethod}
                      onChange={(e) =>
                        handlePersonalInfoChange(
                          "paymentMethod",
                          e.target.value
                        )
                      }
                    >
                      <option value="Giro">Giro</option>
                      <option value="Credit Card">Credit Card</option>
                      <option value="PayPal">PayPal</option>
                      {/* Add more payment methods as needed */}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-sm-5">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                  </div>
                  <div className="col-sm-7">
                    <input
                      type="text"
                      id="address"
                      className="form-control"
                      value={personalInfo.address}
                      onChange={(e) =>
                        handlePersonalInfoChange("address", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handlePersonalInfoUpdate}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
      <Footer />
    </>
  );
};

export default ProjectDetails;
